<template>
  <div class="pb-9">
    <v-row class="">
      <v-col cols="12" md="12">
        <!-- <v-card-title class="text-h4 font-weight-bold mb-5">
          {{ $t('integrations.title') }}
        </v-card-title> -->

      </v-col>
      
    </v-row>
    <v-card color="" elevation="0" class="">
      <v-divider></v-divider>
        <v-tabs color="primary" class="" height="80" background-color="#f4f4f4">
          <div class="d-flex align-center px-4">
            <v-icon color="primary" size="">mdi-connection</v-icon>
      <h5 class="font-weight-bold headline ml-2">{{ $t('integrations.title') }}</h5>
      
      </div>
          <v-tab class="ml-4" @click="filter.type = ['crm', 'erp', 'adserver']">{{$t('integrations.types.all')}}</v-tab>
          <v-tab @click="filter.type = ['crm']">{{$t('integrations.types.crm')}}</v-tab>
          <v-tab @click="filter.type = ['erp']">{{$t('integrations.types.erp')}}</v-tab>
          <v-tab @click="filter.type = ['adserver']">{{$t('integrations.types.adserver')}}</v-tab>
          <v-tab @click="filter.type = ['payment']">{{$t('integrations.types.payment')}}</v-tab>
          <v-tab @click="filter.type = ['marketing']">{{$t('integrations.types.marketing')}}</v-tab>
          <v-tab @click="filter.type = ['programatic']">{{$t('integrations.types.programatic')}}</v-tab>
        </v-tabs>
    <div class="d-flex flex-wrap px-4">
<template  v-for="item in integrations" >
      <v-card :color="item.color" :key="item.id" height="200" :disabled="item.status == 'wip'" @click="openItem(item)"
        class="mr-4 mt-4 pa-3 d-flex flex-column -integration-card" style="place-content: space-between; position: relative">
          <v-img :style="item.status !== $t('common.active') ? 'opacity: .5' : ''" contain :src="item.logo" height="180"></v-img>
          <v-chip :color="$t(`integrations.color.${item.category}`)" class="white--text darken-2" style="position: absolute; z-index: 1; bottom: 5px; right: 5px;">{{ $t(`integrations.types.${item.category}`) }}</v-chip>
          <v-chip label color="orange" class="white--text" style="position: absolute; z-index: 1; bottom: 5px; left: 5px;" v-if="item.status == 'wip'">{{ $t(`integrations.underDev`) }}</v-chip>
          <v-chip label color="green" class="white--text" style="position: absolute; z-index: 1; bottom: 5px; left: 5px;" v-if="item.status == $t('common.active')">{{ item.status }}</v-chip>
          <v-chip label color="red" class="white--text" style="position: absolute; z-index: 1; bottom: 5px; left: 5px;" v-if="item.status == $t('common.inactive')">{{ item.status }}</v-chip>
          <v-chip label color="blue" class="white--text" style="position: absolute; z-index: 1; bottom: 5px; left: 5px;" v-if="item.status == 'allow'">{{ $t('common.allowed')}}</v-chip>
       
      </v-card>
    </template>
     
    </div>
    </v-card>
    <!-- <v-dialog v-model="config.open" max-width="768">
      <v-card v-if="config.open">
        <v-card-title>
          <span>Configuraciones - {{ config.app }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="config.open = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-card class="d-flex justify-space-between align-center" elevation="0">
            <div>Ativar {{ config.app }}</div>
            <v-switch v-model="config.enabled"></v-switch>
          </v-card>
          <v-divider></v-divider>
          <v-card elevation="0" class="d-flex align-center justify-space-between">
            <div>Leads</div>
            <v-switch v-model="config.leads"></v-switch>
          </v-card>
          <v-card elevation="0" disabled class="d-flex align-center justify-space-between">
            <div>Pedidos <v-chip label small color="orange" class="white--text ml-3">{{ $t(`integrations.underDev`) }}</v-chip></div>
            <v-switch v-model="config.orders"></v-switch>
          </v-card>
          
          <div class="d-flex pt-6">
            <v-spacer></v-spacer>
            <v-btn text class="mr-1" @click="config.open = false">{{ $t('common.cancel') }}</v-btn>
            <v-btn @click="save()" color="success" elevation="0">{{ $t('common.save') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog> -->
    <v-snackbar v-model="saved" color="green" :timeout="5000"  >
      <v-icon>mdi-checked</v-icon> La configuración de integración se actualizó correctamente.
      <template v-slot:action="{ attrs }">
        <v-btn small light icon v-bind="attrs" @click="saved = false">
         <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { mapGetters, mapActions, mapState } from "vuex";


export default {
  name: "IntegrationsView",
  data() {
    return {
      saved: false,
      tabs: 0,
      filter: {
        type: ['crm', 'erp', 'adserver', 'payment', 'marketing', 'programatic']
      },
      config: {
        open: false,
        enabled: false,
        app: null,
        leads: false,
        orders: false
      },
      apps: [
        {
          id: 0,
          name: "Pipe Drive",
          logo: require("@/assets/apis/pipedrive.svg"),
          category: 'crm',
          color: '#fff',
          status: 'wip',
          code: 'pipedrive'
        },
        {
          id: 1,
          name: "Sales Force",
          logo: require("@/assets/apis/salesforce.svg"),
          category: 'crm',
          color: '#fff',
          status: 'wip',
          code: 'salesforce'
        },
        {
          id: 5,
          name: "Google Ad Manager 360",
          logo: require("@/assets/apis/google-adManager.jpeg"),
          category: 'adserver',
          color: '#fff',
          status: 'allow',
          code: 'googleadmanager'
        },
        {
          id: 3,
          name: "Oracle ERP",
          logo: require("@/assets/apis/logo-oracle.jpeg"),
          category: 'erp',
          color: '#fff',
          status: 'wip',
          code: 'oracleerp'
        },
        {
          id: 2,
          name: "ZenDesk",
          logo: require("@/assets/apis/zendesk.svg"),
          category: 'crm',
          color: '#fff',
          status: 'wip',
          code: 'zendesk'
        },
        {
          id: 4,
          name: "SAP ERP",
          logo: require("@/assets/apis/sap-erp.png"),
          category: 'erp',
          color: '#fff',
          status: 'wip',
          code: 'sap'
        },
        {
          id: 6,
          name: "OMIE ERP",
          logo: require("@/assets/apis/logo-omie.jpeg"),
          category: 'erp',
          color: '#fff',
          status: 'wip',
          code: 'omie'
        },
        {
          id: 7,
          name: "ZOHO CRM",
          logo: require("@/assets/apis/zoho-crm.jpeg"),
          category: 'crm',
          color: '#fff',
          status: 'wip',
          code: 'zoho'
        },
        {
          id: 8,
          name: "VTiger CRM",
          logo: require("@/assets/apis/vtiger.png"),
          category: 'crm',
          color: '#fff',
          status: 'allow',
          code: 'vtiger'
        },
        {
          id: 9,
          name: "TOTVS CRM",
          logo: require("@/assets/apis/totvscrm.png"),
          category: 'crm',
          color: '#fff',
          status: 'wip',
          code: 'totvs'
        },
        {
          id: 9,
          name: "PAGARME",
          logo: require("@/assets/apis/pagarme.png"),
          category: 'payment',
          color: '#fff',
          status: 'allow',
          code: 'pagarme'
        },
        {
          id: 10,
          name: "OPEN PAY",
          logo: require("@/assets/apis/openpay.png"),
          category: 'payment',
          color: '#fff',
          status: 'allow',
          code: 'openpay'
        },
        {
          id: 11,
          name: "AD MOOH",
          logo: require("@/assets/apis/logo-admooh.jpeg"),
          category: 'programatic',
          color: '#fff',
          status: 'wip',
          code: 'admooh'
        },
        {
          id: 12,
          name: "RD STATION",
          logo: require("@/assets/apis/logo-rdstation.jpeg"),
          category: 'marketing',
          color: '#fff',
          status: 'wip',
          code: 'rdstation'
        },
        {
          id: 13,
          name: "MAILCHIMP",
          logo: require("@/assets/apis/logo-mailchimp.jpeg"),
          category: 'marketing',
          color: '#fff',
          status: 'wip',
          code: 'mailchimp'
        }
      ]
     
    }
  },
  methods: {
    ...mapActions("snackbar", "getMasterStore", ["showSnack"]),
    openItem(item){
      if(item.status != 'wip'){
        console.log
        const snap = this.masterStore.hasOwnProperty('integrations') &&  this.masterStore.integrations.hasOwnProperty(item.code) ? JSON.parse(JSON.stringify(this.masterStore.integrations[item.code])) : {enabled: false, leads: false, orders: false}
        console.log('snap', snap)
        this.config.open = true
        this.config.app = item.name
        this.config.enabled = snap.enabled
        this.config.leads = snap.leads
        this.config.orders = snap.orders
      }
    },
    save(){
      setTimeout(() => {
        this.saved = true
      },100)
    }
  },
  computed:{
    ...mapState("groupStores", [
      "masterStore"
    ]),
    integrations(){
      return this.allIntegrations.filter(i => this.filter.type.includes(i.category))
    },
    allIntegrations(){
      const res = this.apps
      const all = []
      if(this.masterStore.hasOwnProperty('integrations')){
        for(let key in this.masterStore.integrations){
          if(key == 'vtiger'){
            const k = res.findIndex(app => app.code == key)
            res[k].status = this.masterStore.integrations.vtiger.leads ? this.$t('common.active') : this.$t('common.inactive')
          }
        }
      }
      return res
    },
    
    
  }
}
</script>
<style lang="scss">
.-integration-card{
  width: calc((100% - 64px)/5);
  &:nth-child(5n){
    margin-right: 0 !important;
  }
}
</style>